import React from 'react'

export const ActionBlocksLoader = () => {
  return (
    <div
      className="relative h-[36px] w-full rounded skeleton"
      data-testid="action-block-loader"
    />
  )
}
